<app-workflow-step-layout [readOnly]="readOnly">
  <ng-container info>
    <div>
      <h3>Verwendete Chargen bei der Normalisierungsplatte</h3>

      <app-batches-selector
        [readOnly]="readOnly"
        [forms]="batchFormArray"
        (onChange)="validateStep()">
      </app-batches-selector>

      <div class="plate-swap-button">
        <core-button
          [text]="'Zur Berechnung wechseln'"
          [backgroundColor]="'#607D8B'"
          (onClick)="switchPlateView()">
        </core-button>
      </div>

    </div>
    <app-position-detail
      [position]="selectedPosition"
      [showChangeStateButton]="!readOnly"
      [showPipettingStatus]="true">
    </app-position-detail>
  </ng-container>
  <ng-container plate>
    <app-plate-view
      [plateSize]="workflowInstance.workflow"
      [plateMode]="PlateMode.PIP_STATUS"
      [workflowInstance]="workflowInstance"
      [plates]="workflowStep?.plates"
      (onPositionSelected)="onCellClick($event)"
      (onClearPositionSelected)="onCellClick(null)">
    </app-plate-view>
  </ng-container>
</app-workflow-step-layout>
